// Login page. Email + password — the staff dropdown was retired so anyone
// can log in from any device by typing their address (no need to discover
// their staff_id). The backend still accepts staff_id under the hood for
// scripting; the user-facing form is email-only.

import { useState } from 'react';
import { login as apiLogin } from '../lib/api.ts';
import { VavaLockup } from '../components/VavaLogo.jsx';

export const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr('');
    if (!email.trim()) return setErr('请输入邮箱');
    if (!pw) return setErr('请输入密码');
    setLoading(true);
    try {
      const { staff: user } = await apiLogin(email.trim(), pw);
      onLogin(user);
    } catch (e) {
      // Surface the server message verbatim so the rate-limit lockout text
      // ("账号已锁定，请 15 分钟后再试...") shows as-is.
      let msg;
      if (e?.status === 401) msg = '邮箱或密码错误';
      else if (e?.status === 429) msg = e?.message || '账号已锁定，请稍后再试';
      else msg = e?.message ?? '登录失败';
      setErr('⚠ ' + msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <VavaLockup width={220} />
          </div>
          <div className="system">待办系统 · Task System</div>
        </div>
        <form className="login-form" onSubmit={submit}>
          <div style={{ marginBottom: 16 }}>
            <label className="vava-label">邮箱 · Email</label>
            <input type="email" className="vava-input"
                   placeholder="your-name@example.com"
                   autoComplete="username"
                   value={email} onChange={(e) => setEmail(e.target.value)}
                   autoFocus disabled={loading} />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label className="vava-label">密碼 · Password</label>
            <input type="password" className="vava-input" placeholder="Password"
                   autoComplete="current-password"
                   value={pw} onChange={(e) => setPw(e.target.value)}
                   disabled={loading} />
          </div>
          <button type="submit" className="btn btn-primary"
                  style={{ width: '100%', justifyContent: 'center' }}
                  disabled={loading}>
            {loading ? '登入中...' : '登入'}
          </button>
          {err && <div className="login-error">{err}</div>}
          <div style={{ marginTop: 16, fontSize: 12, color: 'var(--vava-text-muted)', textAlign: 'center' }}>
            没有账号？请联系 Regina 邀请。
          </div>
        </form>
        <div className="login-footer">VaVa Designer Cakes · Internal Use Only</div>
      </div>
    </div>
  );
};
